var path = '/modules/media/components/al-media-manager/sub-components/drop-zone/component.tpl.html';
var html = "<div class=\"al-media-manager-drop-zone\">\n    <span class=\"status-label status-{{vm.currentState}}\"><strong\n            ng-if=\"vm.currentState === 'error'\">{{'general.verbs.error'|translate}}: </strong><span\n            ng-bind-html=\"vm.statusLabels[vm.currentState]\"></span></span>\n\n    <div class=\"dropzone-container status-{{vm.currentState}}\">\n\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/media/components/al-media-manager/sub-components/drop-zone/component.tpl.html
// module id = 2132
// module chunks = 1